// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"115":"585f91ff","137":"d8afa60a","197":"9ff843e5","209":"1d92af60","249":"b92d8cd7","280":"6c5287e0","391":"261b8742","620":"08845d24","727":"4a84e378","761":"493bee5b","793":"e7bd64c8","903":"e5484c74","948":"80497e2a","980":"07ae7358"}[chunkId] + ".js";
};